"use strict";
/**
 * ************************************
 *
 * @module next-persist
 * @author most-js
 * @description module that contains function to get state from cookies
 *
 * ************************************
 */
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getCookieStore = void 0;
var js_cookie_1 = __importDefault(require("js-cookie"));
function getCookieStore(key, state) {
    var stateFromCookie = js_cookie_1.default.get(key);
    return stateFromCookie ? JSON.parse(stateFromCookie) : state;
}
exports.getCookieStore = getCookieStore;
